// removed by extract-text-webpack-plugin
module.exports = {"ApiccoLanding":"ApiccoLanding__ApiccoLanding___35WBL","navContainer":"ApiccoLanding__navContainer___3fjNO","logo":"ApiccoLanding__logo___1IOFy","hammy":"ApiccoLanding__hammy___3yGEZ","contentContainer":"ApiccoLanding__contentContainer___poVnO","subHeading":"ApiccoLanding__subHeading___2a1Vw","mainHeading":"ApiccoLanding__mainHeading___3Rw-O","link":"ApiccoLanding__link___3XqgU","imgContainer":"ApiccoLanding__imgContainer___2rceu","image":"ApiccoLanding__image___dTCkm","shape":"ApiccoLanding__shape___169nL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPages/ApiccoLanding/ApiccoLanding.css
// module id = 207
// module chunks = 0